import type { IssueListingType } from '../issues/getIssueList'
import { apiRequestWrapper } from '~/helpers/apiRequestWrapper'
import type { Company } from '~/types/Company'

export type CompanyListingType = Array<Company['attributes'] & { id: number } & { issues: IssueListingType }>

export async function getCompanyList() {
  const token = useStrapiToken()

  return apiRequestWrapper<CompanyListingType>(`/issuers/companies`, {}, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token.value}`,
    },
  })
}
